import React, { PureComponent } from "react";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import { Button } from "@material-ui/core";
import { NextIcon } from "components/Icon";
import { Article, Award } from "services/entities/content";
import { loadArticles, loadAwards } from "services/content";
import { handleError } from "util/errors";
import ProgressSpinner from "components/ProgressSpinner";
import config from "config";

interface PressAndAwardsState {
  awards: Award[] | null;
  displayedAwards: number;
  articles: Article[] | null;
  displayedArticles: number;
}

export default class PressAndAwardsPage extends PureComponent<
  {},
  PressAndAwardsState
> {
  static ARTICLES_PAGE_SIZE = 3;
  static AWARDS_PAGE_SIZE = 6;

  state: PressAndAwardsState = {
    awards: null,
    displayedAwards: PressAndAwardsPage.AWARDS_PAGE_SIZE,
    articles: null,
    displayedArticles: PressAndAwardsPage.ARTICLES_PAGE_SIZE,
  };

  componentDidMount(): void {
    loadArticles().then(
      (articles) => this.setState({ articles: articles }),
      (err) => handleError("Failed loading articles", err)
    );
    loadAwards().then(
      (awards) => this.setState({ awards: awards }),
      (err) => handleError("Failed loading awards", err)
    );
  }

  onViewArticleClick = (url: URL) => {
    window.open(url.href);
  };

  onLoadMoreArticles = () => {
    this.setState({
      displayedArticles:
        this.state.displayedArticles + PressAndAwardsPage.ARTICLES_PAGE_SIZE,
    });
  };

  onLoadMoreAwards = () => {
    this.setState({
      displayedAwards:
        this.state.displayedAwards + PressAndAwardsPage.AWARDS_PAGE_SIZE,
    });
  };

  renderArticle = (article: Article, key: number) => {
    return (
      <article key={key}>
        {article.source && <div className="source">{article.source}</div>}
        <h3>{article.title}</h3>
        <div className="date">{article.date.format("MMMM DD, YYYY")}</div>
        {article.url && (
          <Button onClick={() => this.onViewArticleClick(article.url)}>
            See article <NextIcon />
          </Button>
        )}
        {article.heroImage && (
          <img src={article.heroImage.href} className="hero" alt="" />
        )}
      </article>
    );
  };

  renderAward = (award: Award, key: number) => {
    return (
      <article key={key}>
        {award.logo && <img src={award.logo.href} className="logo" alt="" />}
        {award.name && <h3>{award.name}</h3>}
        <div className="award">{award.description}</div>
        {award.url && (
          <Button onClick={() => this.onViewArticleClick(award.url)}>
            See article <NextIcon />
          </Button>
        )}
      </article>
    );
  };

  render() {
    let articles: Article[] | null = this.state.articles;
    let hasMoreArticles = false;
    if (articles && this.state.displayedArticles < articles!.length) {
      articles = articles!.slice(0, this.state.displayedArticles);
      hasMoreArticles = true;
    }
    let awards: Award[] | null = this.state.awards;
    let hasMoreAwards = false;
    if (awards && this.state.displayedAwards < awards!.length) {
      awards = awards!.slice(0, this.state.displayedAwards);
      hasMoreAwards = true;
    }
    return (
      <DefaultLayout id="press-and-awards-page">
        <section className="banner">
          <p>What we are proud of</p>
          <h1>Press & Awards</h1>
          <p>
            Sook has been busy making the headlines. Read our latest press below
            or{" "}
            <a href={config.contact.newsletter} className="link" target="_blank" rel="noopener noreferrer">
              sign up to our newsletter.
            </a>{" "}
            For media enquiries, please contact Jenni Rayner at{" "}
            <a href={"mailto:" + config.contact.jenni} className="link">
              {config.contact.jenni}
            </a>
          </p>
        </section>
        <section className="press-coverage">
          <h2>Press coverage</h2>
          {articles && articles!.map(this.renderArticle)}
          {articles === null && <ProgressSpinner />}
          {articles !== null && articles!.length === 0 && (
            <p className="empty-message">No articles found</p>
          )}
          {hasMoreArticles && (
            <Button className="more" onClick={this.onLoadMoreArticles}>
              Load more
            </Button>
          )}
        </section>
        <hr />
        <section className="awards-and-partners">
          <h2>Awards &amp; Partners</h2>
          {awards && awards!.map(this.renderAward)}
          {awards === null && <ProgressSpinner />}
          {awards !== null && awards!.length === 0 && (
            <p className="empty-message">No awards found</p>
          )}
          {hasMoreAwards && (
            <Button className="more" onClick={this.onLoadMoreAwards}>
              Load more
            </Button>
          )}
        </section>
      </DefaultLayout>
    );
  }
}
